var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _path28, _path29, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClap = function SvgClap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181,
    height: 127,
    fill: "none",
    viewBox: "0 0 181 127"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.782,
    d: "M87.066 77.218c-2.767 3.579-10.862 1.905-18.086-3.734-7.25-5.64-10.862-13.107-8.12-16.686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_1578_14470)",
    d: "M104.51 39.032s3.637.72 5.097.49c1.461-.233 3.612-.49 3.612-.49s.231-14.085.257-18.257c.025-4.171 0-10.12 0-10.943s-.487-2.447-2.665-2.19-5.559 2.19-5.559 7.803.231 7.313.231 9.013c0 1.699-2.177 11.432-2.177 11.432l-.487 2.678z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_1578_14470)",
    d: "M98.568 9.445a1.09 1.09 0 0 0-1.076-1.005c-1.23-.025-3.33.31-4.612 2.601-1.946 3.4-.204 12.67-.204 14.369 0 1.596-.538 9.012-.718 9.913 0 .052-.999.103-.948.129.462.18 2.665 1.03 4.483.515 1.845-.515 4.637-2.008 5.098-2.24.051-.026.077-.077.051-.103z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_1578_14470)",
    d: "M108.148 34.242s-.487-17.098-.718-21.012c-.23-3.888 0-9.862 0-10.223 0-.36-.973-1.957-2.894-2.188-1.947-.232-4.483 2.188-4.842 5.124 0 0-1.204 15.578-.973 16.789.23 1.21-1.46 11.278-1.46 11.278s.973 1.159 4.611 1.39c3.612.232 6.276-1.158 6.276-1.158"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_1578_14470)",
    d: "M108.148 34.242s-.487-17.098-.718-21.012c-.23-3.888 0-9.862 0-10.223 0-.36-.973-1.957-2.894-2.188-1.947-.232-4.483 2.188-4.842 5.124 0 0-1.204 15.578-.973 16.789.23 1.21-1.46 11.278-1.46 11.278s.973 1.159 4.611 1.39c3.612.232 6.276-1.158 6.276-1.158"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_1578_14470)",
    d: "M104.51 39.032s3.637.72 5.097.49c1.461-.233 3.612-.49 3.612-.49s.231-14.085.257-18.257c.025-4.171 0-10.12 0-10.943s-.487-2.447-2.665-2.19-5.559 2.19-5.559 7.803.231 7.313.231 9.013c0 1.699-2.177 11.432-2.177 11.432l-.487 2.678z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_1578_14470)",
    d: "M96.286 66.79s-4.842 1.7-7.276 0c-2.433-1.7-5.328-3.889-4.61-11.69.717-7.803 1.716-7.494 1.716-12.592s.486-7.082.486-7.082 10.631-1.982 14.039-1.725c3.381.232 11.63 3.167 11.63 3.167l-.487 21.553-2.792 10.274z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_1578_14470)",
    d: "M110.683 60.841c2.177-.18 7.275-2.678 7.275-7.802V23.324s-1.204-2.318-3.868-2.19c-2.664.13-7.993 3.168-4.611 16.79 0 0-9.683 5.356-9.453 12.411.256 7.081 4.611 10.995 10.657 10.506"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF5968",
    d: "M93.006 26.517s-.359-4.455-.41-5.742c-.103-2.034-4.304-3.502-4.919.386S86.473 33.315 86.5 36.74c.026 3.424 5.303 1.236 5.303 1.236z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#A72E40",
    d: "M89.803 38.928s9.222-3.605 18.701-.515c0 0-9.479-4.12-18.7.515"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M155.663 101.52c9.695-14.338 9.737-31.301.094-37.888-9.642-6.587-25.317-.303-35.011 14.035s-9.737 31.301-.094 37.888c9.642 6.587 25.317.303 35.011-14.035M175.366 67.381c3.042 0 5.508-2.479 5.508-5.536 0-3.058-2.466-5.536-5.508-5.536s-5.507 2.478-5.507 5.536 2.466 5.536 5.507 5.536"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F36",
    d: "m170.09 37.588-4.329 6.386c-.666 1.004-.41 2.369.589 3.039s2.357.412 3.023-.593l4.329-6.386c.666-1.004.41-2.369-.589-3.038a2.173 2.173 0 0 0-3.023.592"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1578_14470",
    width: 75,
    height: 80,
    x: 87,
    y: 39,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M155.663 101.52c9.694-14.338 12.883-32.111-31.686-59.408-9.642-6.587-25.317-.303-35.011 14.035s22.043 52.821 31.685 59.408 25.318.303 35.012-14.035"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1578_14470)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F1048",
    d: "M137.578 71.5s-3.56-5.51-4.739-5.716c-1.153-.206-12.168 1.597-15.754 4.687s-12.732 13.673-13.654 16.222-.948 4.635 4.431 5.408c5.38.772 27.411-9.013 27.411-9.013z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2.577,
    d: "M122.463 83.53c8.453-6.563 13.63-14.064 11.563-16.754s-10.595.45-19.049 7.014c-8.453 6.563-13.63 14.065-11.563 16.755s10.595-.45 19.049-7.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_1578_14470)",
    d: "M132.84 72.145s-10.657-11.201-11.861-12.67c-1.204-1.467-2.664-1.699-3.151-7.312-.486-5.588-14.038 2.91-14.038 2.91s-15.985 8.034-12.604 12.411c3.382 4.378 18.419 21.656 18.419 21.656s10.17-.721 15.755-5.846c5.559-5.124 7.505-10.814 7.505-10.814"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m108.377 90.402-5.559-5.588c-.717-.721.487-2.446.487-2.446l1.46 1.467s7.506 0 15.498-6.334c7.993-6.335 7.993-10.223 7.993-10.223l-.487-1.468s.717-.231 1.691.49c.973.72 3.381 3.399 3.381 3.399l5.329 4.866-9.197 12.901-15.268 6.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_1578_14470)",
    d: "m168.216 100.933-34.147-34.324s2.177 5.587-8.223 14.11-17.471 11.69-21.57 9.991l30.997 33.604c0-.026 17.676 2.42 32.943-23.381"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2.577,
    d: "M103.433 90.298c2.075 2.678 10.58-.464 19.034-7.004s13.628-14.06 11.553-16.737"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3.029,
    d: "M119.853 103.302a2.26 2.26 0 0 0 2.254-2.266 2.26 2.26 0 0 0-2.254-2.266 2.26 2.26 0 0 0-2.254 2.266 2.26 2.26 0 0 0 2.254 2.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.543,
    d: "M120.416 109.096s9.094.901 20.211-8.755c9.351-8.111 10.657-16.609 10.529-16.738"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_1578_14470)",
    d: "M120.795 77.683c-9.709 14.343-9.734 31.312-.077 37.904s25.336.309 35.019-14.034 9.735-31.311.077-37.903-25.335-.31-35.019 14.033"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC6F",
    d: "m41.364 58.189 13.987 18.514 23.132.772L65.29 96.607l6.405 22.325-22.16-6.695-19.16 13.03-.513-23.252-18.24-14.291 21.826-7.674zM14.62 122.486c4.244 0 7.685-3.459 7.685-7.725 0-4.267-3.44-7.725-7.685-7.725s-7.685 3.458-7.685 7.725 3.44 7.725 7.685 7.725"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F36",
    d: "M3.091 104.718a3.08 3.08 0 0 0 3.074-3.089 3.08 3.08 0 0 0-3.074-3.09 3.08 3.08 0 0 0-3.074 3.09 3.08 3.08 0 0 0 3.074 3.089"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_1578_14470)",
    d: "m68.803 34.035.512-17.768s4.355-2.317 5.123 2.575c.769 4.893.769 13.648.769 13.648s-2.818 4.377-6.404 1.544"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC2CA",
    d: "M83.532 52.703c0 4.12 1.28 11.33 7.172 11.072 5.893-.257 9.94-6.695 10.504-11.072.563-4.378 1.793-16.737 2.817-21.115 1.025-4.377 1.537-8.497-1.537-9.785-3.074-1.287-5.891 4.893-6.66 9.013s-1.793 10.815-4.355 13.132-7.941 6.438-7.941 8.755"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_1578_14470)",
    d: "m73.542 28.24 1.485-23.354c.026-.515.436-.953.948-1.004 1.512-.18 4.509-.13 5.252 2.729 1.024 3.863 0 23.098 0 23.098s-3.843 3.682-7.686-1.468"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_1578_14470)",
    d: "M79.175 30.816S80.455 1.204 80.968.689c.564-.567 7.429-1.545 7.429 5.922 0 7.468-.769 28.325-.769 28.325s-5.635 2.833-8.453-4.12"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_1578_14470)",
    d: "M86.605 32.618s.769-25.234 1.025-26.522 5.892-1.287 7.429 4.12c1.537 5.408.768 21.372 0 25.75-.769 4.377-5.892 4.12-5.892 4.12s-2.818-1.03-2.562-7.468"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC2CA",
    d: "M94.16 57.75s-5.046 10.326-18.06 4.481c-11.476-5.15-10.477-10.016-9.222-13.57.18-.49.359-.927.512-1.365 1.281-3.605 1.486-15.784 1.486-15.784s1.076-3.528 5.687-3.528 16.702 8.034 16.702 8.034l5.431-.515z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC2CA",
    d: "M63.985 54.223s2.305-3.528 3.1-6.129c0 0 .998 3.013 0 4.326-.974 1.313-3.1 1.803-3.1 1.803"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1578_14470",
    width: 91,
    height: 82,
    x: 11,
    y: 44,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC6F",
    d: "m41.364 58.188 30.33-14.187 29.317 26.274-30.951 30.049 1.635 18.608-22.16-6.695-19.16 13.03-.513-23.253-18.24-14.29 21.826-7.674z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1578_14470)"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC2CA",
    d: "m10.263 112.443 56.358-60.77s8.71-4.12 15.37 0 7.173 11.33 7.173 11.33L32.55 135.875s-18.956-.772-22.287-23.432"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F1048",
    d: "m37.673 132.167.359-.438 44.983-55.697s-1.793-9.012-10.247-14.934c-8.453-5.923-14.858-2.833-14.858-2.833l-45.854 48.152 8.71 20.858"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1578_14470",
    width: 72,
    height: 76,
    x: 12,
    y: 57,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F1048",
    d: "m37.673 132.168.359-.438 44.983-55.697s-1.793-9.012-10.247-14.935c-8.453-5.922-14.858-2.832-14.858-2.832l-45.854 48.152 8.71 20.857"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 29.076,
    mask: "url(#mask2_1578_14470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.094 97.405s.768-4.274-1.281-6.18M65.34 88.393s3.586 4.12 3.586 7.21M80.453 83.758s1.793-4.893-3.33-8.24M61.243 78.608s3.842-1.03 5.892-5.15M64.185 52.935l-.256 9.657M49.38 57.467s-.922 6.464 2.408 7.494M46.1 76.033l4.662.438M45.332 86.076s-3.56 2.06-3.304 5.407M39.21 100.753s2.792.952 2.792 5.51M13.209 110.898s1.23 2.704-2.024 5.846M16.41 131.035s-1.768-2.369.768-6.128M62.267 108.22h-9.325M23.07 86.849s6.148-.515 9.222 1.03M45.332 121.919s-3.048-3.373-5.61-4.918M24.095 112.598s4.226-.515 5.84 0M28.552 100.752s-3.92-.772-8.275 1.03M33.832 126.76s-.41-3.605-7.429-3.605"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_1578_14470)",
    d: "m41.34 58.2 13.987 18.514 23.133.773-13.193 19.132 6.404 22.325-22.159-6.695-19.161 13.029-.512-23.252-18.24-14.291 21.826-7.674z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.782,
    d: "M60.857 56.824c2.766-3.58 10.861-1.905 18.085 3.734 7.25 5.639 10.862 13.106 8.121 16.686"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#F36",
    d: "M80.431 6.38s2.05-.953 2.332-2.55c.281-1.596 0-2.574 0-2.574S81.738.432 80.969.689zM74.794 9.701s1.947-.9 2.203-2.42 0-2.446 0-2.446-.948-.799-1.69-.541zM69.054 20.697s1.691-.902 1.845-2.163c.128-1.288-.18-2.009-.18-2.009s-.922-.592-1.562-.335zM87.294 11.864s2.075-1.107 2.254-2.73c.18-1.622-.205-2.549-.205-2.549s-1.127-.746-1.921-.437zM102.23 27.984c1.665.077 2.075-.85 2.305-1.751.231-.901 0-2.961 0-2.961s-2.408-.824-2.92-.284c-.487.515-2.126 4.867.615 4.996"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1578_14470",
    x1: 110.322,
    x2: 108.487,
    y1: 13.74,
    y2: 33.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#BF5968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1578_14470",
    x1: 95.3,
    x2: 95.969,
    y1: 20.929,
    y2: 38.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#BF5968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1578_14470",
    x1: 102.202,
    x2: 102.87,
    y1: 14.071,
    y2: 35.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#BF5968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1578_14470",
    x1: 106.468,
    x2: 95.82,
    y1: 18.928,
    y2: 16.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#BF5968",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1578_14470",
    x1: 110.953,
    x2: 102.224,
    y1: 23.828,
    y2: 22.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#BF5968",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1578_14470",
    x1: 86.748,
    x2: 113.493,
    y1: 55.478,
    y2: 47.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#BF5968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1578_14470",
    x1: 114.114,
    x2: 98.682,
    y1: 43.532,
    y2: 31.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#BF5968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1578_14470",
    x1: 105.721,
    x2: 124.123,
    y1: 66.996,
    y2: 73.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#BF5968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1578_14470",
    x1: 110.772,
    x2: 130.28,
    y1: 117.361,
    y2: 102.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1578_14470",
    x1: 136.458,
    x2: 142.774,
    y1: 77.372,
    y2: 119.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#FC0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1578_14470",
    x1: 72.169,
    x2: 77.201,
    y1: 24.974,
    y2: 22.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#FEC2CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1578_14470",
    x1: 73.665,
    x2: 84.115,
    y1: 18.199,
    y2: 15.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#FEC2CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1578_14470",
    x1: 81.603,
    x2: 90.825,
    y1: 17.905,
    y2: 17.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#FEC2CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1578_14470",
    x1: 89.776,
    x2: 100.618,
    y1: 22.723,
    y2: 22.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#FEC2CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1578_14470",
    x1: 54.63,
    x2: 26.143,
    y1: 90.221,
    y2: 114.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#00CC6F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CC6F"
  })))));
};
export default SvgClap;